import { Locales } from '@ratehub/base-ui';

import createCreditCardDetailsStaticProps from '../functions/createCreditCardDetailsStaticProps';
import withEnglishLocale from '../functions/withEnglishLocale';
import CreditCardDetailsPage from '../components/CreditCardDetailsPage';


const { getStaticPaths, getStaticProps } = createCreditCardDetailsStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'ccDetailsSlugEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/credit-cards/card', // Array to determine the url - final result is `/${rootPath.join('/')}`
});

export default withEnglishLocale(CreditCardDetailsPage);
export { getStaticPaths, getStaticProps };

